import { isBeta, isDev, isTest } from '@shopping/common'
import { SubVertical } from 'common/constants/verticalService'

export enum MenuType {
  PRODUCT = 'PRODUCT',
  LINK = 'LINK',
  SEASONAL_FOOD = 'SEASONAL_FOOD',
}

export enum MenuAlias {
  LOCAL_MARKET = 'LOCAL_MARKET',
  FOOD_THEME = 'food_theme',
  FOOD_COOKING = 'food_cooking',
  FOOD_REGION = 'food_region',
  FOOD_INGREDIENTS = 'food_ingredients',
  DIRECT_FARM_PRODUCT = 'DIRECT_FARM_PRODUCT',
  LOCAL_FOOD_PRODUCT = 'LOCAL_FOOD_PRODUCT',
}

export const MenuAliasMapping: { [subVertical in SubVertical]?: MenuAlias[] } = {
  LOCAL_FOOD: [MenuAlias.LOCAL_MARKET],
  HOME_MEAL: [MenuAlias.FOOD_THEME, MenuAlias.FOOD_COOKING, MenuAlias.FOOD_REGION, MenuAlias.FOOD_INGREDIENTS],
}

export const ProductMenuAlias: { [subVertical in SubVertical]?: MenuAlias } = {
  DIRECT_FARM: MenuAlias.DIRECT_FARM_PRODUCT,
  LOCAL_FOOD: MenuAlias.LOCAL_FOOD_PRODUCT,
}

export enum MenuEnv {
  DEVELOPMENT = 'DEVELOPMENT',
  BETA = 'BETA',
  PRODUCTION = 'PRODUCTION',
}

export const findMenuEnv = (): MenuEnv => {
  if (isDev || isTest) {
    return MenuEnv.DEVELOPMENT
  }
  if (isBeta) {
    return MenuEnv.BETA
  }
  return MenuEnv.PRODUCTION
}
